<template>
    <div>
    <!-- 详情 --> 
    <a-drawer
            width="80%"
            :height="340"
            :visible="detailVisible"
            placement="right"
            :footer="false"
            @cancel="handleCancel"
            unmountOnClose
    >
        <template #title>{{title}}</template>
        <a-spin :loading="loading" tip="Loading...">
            <!-- 发货 -->
            <div v-if="detail.type === 0">
                <!-- 订单基础信息 -->
                <a-divider orientation="left" style="font-weight:600"><icon-star /> {{ $t('order.baseInfo') }}</a-divider>
                <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.orderName')" /></span> 
                            <span class="fieldValue">{{detail.order_name}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.status')" /></span> 
                            <span class="fieldValue" :style="{'color':detail.status_val == 1? 'red' : 'green'}">{{detail.status}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.source')" /></span> 
                            <span class="fieldValue">{{detail.source}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.orderType')" /></span> 
                            <span class="fieldValue">{{detail.order_type}}</span> 
                        </div>
                        <div class="detailItem" v-if="detail.order_type_val == 1">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.orderUse')" /></span> 
                            <span class="fieldValue">{{detail.order_use}}</span> 
                        </div>
                        <div class="detailItem" v-if="detail.order_type_val == 1">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.backFlag')" /></span> 
                            <span class="fieldValue">{{detail.back_flag}}</span> 
                        </div>
                    </div>
                    <div class="detailItem_right">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.orderChannelType')" /></span> 
                            <span class="fieldValue">{{detail.order_channel_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.orderDate')" /></span> 
                            <span class="fieldValue">{{detail.order_timestamp}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.signTime')" /></span> 
                            <span class="fieldValue">{{detail.sign_time}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.deliveryType')" /></span> 
                            <span class="fieldValue">{{detail.delivery_type}}</span> 
                        </div>
                        <!-- <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.taxRate')" /></span> 
                            <span class="fieldValue">{{detail.tax_rate}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.preAfterTax')" /></span> 
                            <span class="fieldValue">{{detail.tax_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.paymentType')" /></span> 
                            <span class="fieldValue">{{detail.payment_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.paymentTypeDiscount')" /></span> 
                            <span class="fieldValue">{{detail.payment_type_discount}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.payTypeDiscount')" /></span> 
                            <span class="fieldValue">{{detail.pay_type_discount}}</span> 
                        </div> -->
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.cargoFreight2')" /></span> 
                            <span class="fieldValue">{{detail.cargo_freight}}</span> 
                        </div>
                    </div>
                </div>

                <a-divider orientation="left" style="font-weight:600"><icon-star /> {{ $t('order.customerInfo') }}</a-divider>
                <!-- 客户信息 -->
                <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.customerName')" /></span> 
                            <span class="fieldValue">{{detail.customer_name}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.customerType')" /></span> 
                            <span class="fieldValue">{{detail.customer_type}}</span> 
                        </div>
                        <!-- <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.customerInvoiceName')" /></span> 
                            <span class="fieldValue">{{detail.customer_invoice_name}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('customer.customerName2')" /></span> 
                            <span class="fieldValue">{{detail.name2}}</span> 
                        </div> -->
                    </div>
                    <div class="detailItem_right">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.customerEmail')" /></span> 
                            <span class="fieldValue">{{detail.customer_email}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.country')" /></span> 
                            <span class="fieldValue">{{detail.country}}</span> 
                        </div>
                    </div> 
                </div>
            </div>

            <!-- 退货 -->
            <div v-if="detail.type == 1">
                <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.orderName')" /></span> 
                            <span class="fieldValue">{{detail.order_name}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.status')" /></span> 
                            <span class="fieldValue" :style="{'color':reissueStatusColor[detail.status_val]}">{{detail.status}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.source')" /></span> 
                            <span class="fieldValue">{{detail.source}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.discount')" /></span> 
                            <span class="fieldValue">{{detail.discount}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backReasonType')" /></span> 
                            <span class="fieldValue">{{detail.back_reason_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backReason')" /></span> 
                            <span class="fieldValue" style="width: 600px;white-space: break-spaces;line-height: 20px;">{{detail.back_reason}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.ibsVerificationType')" /></span> 
                            <span class="fieldValue">{{detail.ibs_verification_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('stock.image')" /></span> 
                            <span v-if="detail.file.length > 0">
                                <a-image
                                    v-for="(item,index) in detail.file"
                                    :key="index"
                                    width="100"
                                    height="100"
                                    :src="item"
                                    show-loader
                                    style="cursor:pointer"
                                />
                            </span>
                            <span v-else>-</span>
                        </div>
                    </div>
                    <div class="detailItem_right">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backCourierStatus')" /></span> 
                            <span class="fieldValue" :style="{'color':courierStatusColor[detail.courier_status_val]}">{{detail.courier_status}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backCourierNo')" /></span> 
                            <span class="fieldValue">{{detail.courier_no}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backCourierType')" /></span> 
                            <span class="fieldValue">{{detail.courier_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('stock.backDate')" /></span> 
                            <span class="fieldValue">{{detail.back_timestamp_val}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('stock.backReceiveDate')" /></span> 
                            <span class="fieldValue">{{detail.back_real_timestamp_val}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.ibsVerificationPlan')" /></span> 
                            <span class="fieldValue">{{detail.ibs_verification_plan}}</span> 
                        </div>
                    </div> 
                </div>
                
            </div>

            <!-- 换货 -->
            <div v-if="detail.type == 2">
                <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.orderName')" /></span> 
                            <span class="fieldValue">{{detail.order_name}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.status')" /></span> 
                            <span class="fieldValue" :style="{'color':reissueStatusColor[detail.status_val]}">{{detail.status}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.source')" /></span> 
                            <span class="fieldValue">{{detail.source}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.discount')" /></span> 
                            <span class="fieldValue">{{detail.discount}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backReasonType')" /></span> 
                            <span class="fieldValue">{{detail.back_reason_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backReason')" /></span> 
                            <span class="fieldValue" style="width: 600px;white-space: break-spaces;line-height: 20px;">{{detail.back_reason}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.ibsVerificationType')" /></span> 
                            <span class="fieldValue">{{detail.ibs_verification_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.swapTimestampPlan')" /></span> 
                            <span class="fieldValue">{{detail.swap_timestamp_plan}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('stock.image')" /></span> 
                            <span v-if="detail.file.length > 0">
                                <a-image
                                    v-for="(item,index) in detail.file"
                                    :key="index"
                                    width="100"
                                    height="100"
                                    :src="item"
                                    show-loader
                                    style="cursor:pointer"
                                />
                            </span>
                            <span v-else>-</span>
                        </div>
                    </div>
                    <div class="detailItem_right">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backCourierStatus')" /></span> 
                            <span class="fieldValue" :style="{'color':courierStatusColor[detail.courier_status_val]}">{{detail.courier_status}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backCourierNo')" /></span> 
                            <span class="fieldValue">{{detail.courier_no}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backCourierType')" /></span> 
                            <span class="fieldValue">{{detail.courier_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.exchangeCourierStatus')" /></span> 
                            <span class="fieldValue">{{detail.swap_courier_status}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.exchangeCourierNo')" /></span> 
                            <span class="fieldValue">{{detail.swap_courier_no}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.exchangeCourierType')" /></span> 
                            <span class="fieldValue">{{detail.swap_courier_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.ibsVerificationPlan')" /></span> 
                            <span class="fieldValue">{{detail.ibs_verification_plan}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.swapTimestampReal')" /></span> 
                            <span class="fieldValue">{{detail.swap_timestamp_real}}</span> 
                        </div>
                    </div>
                </div>
            </div>

            <!-- 补寄 -->
            <div v-if="detail.type == 3">
                <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.orderName')" /></span> 
                            <span class="fieldValue">{{detail.order_name}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.status')" /></span> 
                            <span class="fieldValue" :style="{'color':reissueStatusColor[detail.status_val]}">{{detail.status}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.source')" /></span> 
                            <span class="fieldValue">{{detail.source}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backReasonType')" /></span> 
                            <span class="fieldValue">{{detail.back_reason_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backReason')" /></span> 
                            <span class="fieldValue" style="width: 600px;white-space: break-spaces;line-height: 20px;">{{detail.back_reason}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('stock.image')" /></span> 
                            <span v-if="detail.file.length > 0">
                                <a-image
                                    v-for="(item,index) in detail.file"
                                    :key="index"
                                    width="100"
                                    height="100"
                                    :src="item"
                                    show-loader
                                    style="cursor:pointer"
                                />
                            </span>
                            <span v-else>-</span>
                        </div>
                    </div>
                    <div class="detailItem_right">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.courierStatus')" /></span> 
                            <span class="fieldValue" :style="{'color':courierStatusColor[detail.courier_status_val]}">{{detail.courier_status}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.courierNo')" /></span> 
                            <span class="fieldValue">{{detail.courier_no}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.courierType')" /></span> 
                            <span class="fieldValue">{{detail.courier_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.returnFactoryTimestampPlan2')" /></span> 
                            <span class="fieldValue">{{detail.swap_timestamp_plan}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.instruction')" /></span> 
                            <span class="fieldValue" style="width: 400px;white-space: break-spaces;line-height: 20px;">{{detail.instruction}}</span> 
                        </div>
                    </div>
                </div>
            </div>

            <!-- 返修 -->
            <div v-if="detail.type == 4">
                <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem">
                        <span class="fieldName"><a-badge status="processing" :text="$t('order.orderName')" /></span> 
                        <span class="fieldValue">{{detail.order_name}}</span> 
                        </div>
                        <div class="detailItem">
                        <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.status')" /></span> 
                        <span class="fieldValue" :style="{'color':reissueStatusColor[detail.status_val]}">{{detail.status}}</span> 
                        </div>
                        <div class="detailItem">
                        <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.source')" /></span> 
                        <span class="fieldValue">{{detail.source}}</span> 
                        </div>
                        <div class="detailItem">
                        <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.discount')" /></span> 
                        <span class="fieldValue">{{detail.discount}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backReasonType')" /></span> 
                            <span class="fieldValue">{{detail.back_reason_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backReason')" /></span> 
                            <span class="fieldValue" style="width: 600px;white-space: break-spaces;line-height: 20px;">{{detail.back_reason}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.ibsVerificationType')" /></span> 
                            <span class="fieldValue">{{detail.ibs_verification_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.returnFactoryTimestampPlan2')" /></span> 
                            <span class="fieldValue">{{detail.swap_timestamp_plan}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('stock.image')" /></span> 
                            <span v-if="detail.file.length > 0">
                                <a-image
                                    v-for="(item,index) in detail.file"
                                    :key="index"
                                    width="100"
                                    height="100"
                                    :src="item"
                                    show-loader
                                    style="cursor:pointer"
                                />
                            </span>
                            <span v-else>-</span>
                        </div>
                    </div>
                    <div class="detailItem_right">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backCourierStatus')" /></span> 
                            <span class="fieldValue" :style="{'color':courierStatusColor[detail.courier_status_val]}">{{detail.courier_status}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backCourierNo')" /></span> 
                            <span class="fieldValue">{{detail.courier_no}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.backCourierType')" /></span> 
                            <span class="fieldValue">{{detail.courier_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.returnFactoryCourierStatus')" /></span> 
                            <span class="fieldValue">{{detail.swap_courier_status}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.returnFactoryCourierNo2')" /></span> 
                            <span class="fieldValue">{{detail.swap_courier_no}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.returnFactoryCourierType2')" /></span> 
                            <span class="fieldValue">{{detail.swap_courier_type}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.ibsVerificationPlan')" /></span> 
                            <span class="fieldValue">{{detail.ibs_verification_plan}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('returnExchange.returnFactoryTimestampReal')" /></span> 
                            <span class="fieldValue">{{detail.swap_timestamp_real}}</span> 
                        </div>
                    </div>
                </div>
            </div>

            <!-- 发货 -->
            <Table v-if="type === 0" :table="shipTable"></Table>

            <!-- 退货、换货、补寄、返修 -->
            <Table v-if="type !== 0" :table="reissueTable"></Table>
        </a-spin>
    </a-drawer>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import { dateToTimestamp, timestampToDate, getNowDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';


    const props = defineProps({
        row:{
            type:Object,
            default:()=>{}
        },
        detailVisible:{
            type:Boolean,
            default:false,
        },
        type:{
            type:Number,
        }
    })

    const emits = defineEmits(['handleCancel'])

    const { t } = useI18n()

    const loading = ref(true)
    const title = ref('')
    const detail = ref({})
    const reasonTypeObj = ref({})
    const sourceObj = ref({})
    const ibsVerificationTypeObj = ref({})
    const shipTable = ref({
        datas:[],
        columns:[
            {
                // title: '出库单号',
                title:t('stock.deliveryNumber'),
                dataIndex: 'delivery_number',
                key:'delivery_number',
                width:'200',
                align:'center',
                ellipsis:true,
                tooltip:true,
                fixed:'left'
            }, 
            {
                // title: 'sku',
                title:t('returnExchange.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },  
            {
                // title: 'ERP编号',
                title:t('returnExchange.erpNo'),
                dataIndex: 'erp_no',
                key:'erp_no',
                width:'120',
                align:'center',
            },
            // {
            //     // title: '订单行号',
            //     title:t('returnExchange.erpLineNo'),
            //     dataIndex: 'erp_line_no',
            //     key:'erp_line_no',
            //     width:'140',
            //     align:'center',
            // },
            {
                // title: 'erp物料编码',
                title:t('returnExchange.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                width:'140',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '数量',
                title:t('stock.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'100',
                align:'center',
            },
            {
                // title: '仓库',
                title:t('order.warehouse'),
                dataIndex: 'warehouse',
                key:'warehouse',
                width:'110',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '物流单号',
                title:t('order.courierNo'),
                dataIndex: 'courier_no',
                key:'courier_no',
                width:'130',
                align:'center',
            },
            // {
            //     // title: '物流状态',
            //     title:t('order.courierStatus'),
            //     dataIndex: 'courier_status',
            //     key:'courier_status',
            //     width:'150',
            //     align:'center',
            // },
            {
                // title: '物流公司',
                title:t('order.courierType'),
                dataIndex: 'courier_type',
                key:'courier_type',
                width:'150',
                align:'center',
            },
        ],
        configs:{
            scroll:{
                // x:1000,
                y: 480
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false
        },
    })
    const reissueTableCol = ref([
            {
                // title: 'mes补寄单号',
                title:t('order.reissueNumber'),
                dataIndex: 'swap_number',
                key:'swap_number',
                width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
                fixed:'left'
            }, 
            {
                // title: 'sku',
                title:t('returnExchange.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },  
            {
                // title: '换货sku',
                title:t('stock.swapSku'),
                dataIndex: 'swap_sku',
                key:'swap_sku',
                width:'150',
                align:'center',
                show:false,
                ellipsis:true,
                tooltip:true,
            },  
            {
                // title: 'ERP编号',
                title:t('returnExchange.erpNo'),
                dataIndex: 'erp_no',
                key:'erp_no',
                width:'150',
                align:'center',
            },
            {
                // title: '订单行号',
                title:t('returnExchange.erpLineNo'),
                dataIndex: 'erp_line_no',
                key:'erp_line_no',
                width:'140',
                align:'center',
            },
            {
                // title: 'erp物料编码',
                title:t('returnExchange.inventoryCode'),
                dataIndex: 'swap_inventory_code',
                key:'swap_inventory_code',
                width:'170',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '数量',
                title:t('returnExchange.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'100',
                align:'center',
            },
            {
                // title: '仓库',
                title:t('returnExchange.warehouse'),
                dataIndex: 'swap_inventory',
                key:'swap_inventory',
                width:'130',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '通用物料名称备注',
                title:t('returnExchange.inventoryRemark'),
                dataIndex: 'inventory_remark',
                key:'inventory_remark',
                width:'200',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
        ])
    const reissueTable = ref({
        datas:[],
        columns:[],
        configs:{
            scroll:{
                // x:1000,
                y: 480
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false
        },
    })
    const reissueStatusObj = ref({
        0:t('returnExchange.initial'),
        1:t('returnExchange.returning'),
        2:t('returnExchange.exchangeProgress'),
        3:t('returnExchange.returnSuccessful'),
        4:t('returnExchange.exchangeSuccessful'),
        5:t('order.replenishing'),
        6:t('order.reissueSuccessful'),
    })
    const reissueStatusColor = ref({
        '0':'blue',
        '1':'red',
        '2':'red',
        '3':'green',
        '4':'green',
        '5':'red',
        '6':'green',
        '-4':'orange',
        '-6':'orange',
    })
    const courierStatus = ref({ // 发货状态
        0:t('order.unship'),
        1:t('order.plan'),
        2:t('order.partialShip'),
        3:t('order.shiped'),
        4:t('order.signedFor'),
        5:t('order.cancel'),
        7:t('order.partialReturn'),
        8:t('order.return'),
        9:t('order.exchange'),
        10:t('order.partialExchange'),
    })
    const courierStatusColor = ref({
        0:'magenta',
        1:'blue',
        2:'orange',
        3:'lime',
        4:'green',
        5:'#86909c',
        6:'#ea7ccc',
        7:'#afb2f5',
        8:'#f71ebb',
        9:'#6e74e0',
        10:'gray',
    })

    const init = ()=>{
        console.log(props.row,'props.row', props.type)
        title.value = props.type === 0? t('stock.shipmentDetail') : props.type == 1? t('stock.returnDetail') : props.type == 2? t('stock.exchangeDetail') : props.type == 3? t('stock.reissueDetail') : t('stock.returnFactoryDetail')
        detail.value = {
            // 补寄，换货，退货
            type:props.row.type,
            order_name:props.row.order_name,
            status:props.row.status,
            status_val:`${props.row.status_val}`,
            source:!props.row.source? '-' : sourceObj.value[props.row.source],
            back_reason_type:!props.row.back_reason_type? '-' : reasonTypeObj.value[props.row.back_reason_type],
            back_reason:!props.row.back_reason? '-' : props.row.back_reason,
            swap_timestamp_plan:!props.row.swap_timestamp_plan? '-' : timestampToDate(props.row.swap_timestamp_plan),
            courier_no:!props.row.courier_no? '-' : props.row.courier_no,
            courier_type:!props.row.courier_type? '-' : props.row.courier_type,
            instruction:!props.row.instruction? '-' : props.row.instruction,
            file:!props.row.file? [] : props.row.file.split(','),

            // 换货
            swap_timestamp_real: !props.row.swap_timestamp_real? '-' :  props.row.swap_timestamp_real,
            ibs_verification_type: !props.row.ibs_verification_type? '-' :  ibsVerificationTypeObj.value[props.row.ibs_verification_type],
            ibs_verification_plan: !props.row.ibs_verification_plan? '-' :  props.row.ibs_verification_plan,
            discount: !props.row.discount? '-' :  '€ ' + props.row.discount,
            swap_courier_no: !props.row.swap_courier_no? '-' :  props.row.swap_courier_no,
            swap_courier_type: !props.row.swap_courier_type? '-' :  props.row.swap_courier_type,
            swap_courier_status: !props.row.swap_courier_status? '-' :  props.row.swap_courier_status,
            courier_status_val:!props.row.back_courier_map? '-' : !props.row.back_courier_map.courier_status? '-' : props.row.back_courier_map.courier_status,
            courier_status: !props.row.back_courier_map? '-' : !props.row.back_courier_map.courier_status? '-' : courierStatus.value[props.row.back_courier_map.courier_status],
        
            // 退货
            back_timestamp_val:!props.row.back_timestamp_val? '-' :  props.row.back_timestamp_val,
            back_real_timestamp_val:!props.row.back_real_timestamp_val? '-' :  props.row.back_real_timestamp_val,
        }

        // 发货
        if(props.type === 0){
            getShipDetail()
            getShipList()
        }

        // 设置表格显示的字段
        reissueTableCol.value.forEach(i=>{
            if(i.key == 'swap_sku') i.show = detail.value.type == 2
            if(i.show == undefined || i.show == true) {
                reissueTable.value.columns.push(i)
            }
        })

        reissueTable.value.columns[0].title = props.type == 3? t('order.reissueNumber') : props.type == 2? t('stock.swapNumber') : props.type == 1? t('returnExchange.backNumber') : t('stock.returnFactoryNumber')
        reissueTable.value.columns[0].dataIndex = props.type == 2 || props.type == 3 || props.type == 4? 'swap_number' : 'back_number'
        reissueTable.value.columns[0].key = props.type == 2 || props.type == 3 || props.type == 4? 'swap_number' : 'back_number'
        reissueTable.value.columns[4].dataIndex = props.type == 2 || props.type == 3 || props.type == 4? 'swap_inventory_code' : 'inventory_code'
        reissueTable.value.columns[4].key = props.type == 2 || props.type == 3 || props.type == 4? 'swap_inventory_code' : 'inventory_code'


        loading.value = false
    }

    const handleCancel = ()=>{
        emits('handleCancel')
    }

    // 获取补寄记录
    const getReissueList = async (type)=>{
        let param = {
            type:type,
            order_id: props.row.order_id,
        }

        reissueTable.value.configs.loading = true
        let res = await OrderApi.getInstance().getReturnExchangeList(param)
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach(i=>{
                i.swap_number = !i.swap_number? '-' : i.swap_number,
                i.sku = type == 3? i.swap_sku : i.sku
                i.swap_sku = i.swap_sku
                i.swap_inventory = !i.swap_inventory? '-' : i.swap_inventory,
                i.erp_no = !i.erp_no? '-' : i.erp_no,
                i.erp_line_no = !i.erp_line_no? '-' : i.erp_line_no,
                i.instruction = !i.instruction? '-' : i.instruction,
                i.inventory_remark = !i.inventory_remark? '-' : i.inventory_remark
            })
            reissueTable.value.datas = res.data
            reissueTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取发货记录
    const getShipList = async (type)=>{
        let param = {
            type:type,
            order_id: props.row.order_id,
        }

        shipTable.value.configs.loading = true
        let res = await StockOutApi.getInstance().getDeliverRecord(param)
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach(i=>{
                i.delivery_number = !i.delivery_number? '-' : i.delivery_number,
                i.erp_no = !i.erp_no? '-' : i.erp_no,
                i.erp_line_no = !i.erp_line_no? '-' : i.erp_line_no,
                i.warehouse = !i.warehouse? '-' : i.warehouse,
                i.courier_no = !i.courier_no? '-' : i.courier_no,
                i.courier_status = !i.courier_status? '-' : i.courier_status,
                i.courier_type = !i.courier_type? '-' : i.courier_type
            })
            shipTable.value.datas = res.data
            shipTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取原因类型
    const getReasonType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "reissue_reason_type"})
        if(res.code == 0){
            reasonTypeObj.value = []
            res.data.length > 0 && res.data.forEach(i=>{
                reasonTypeObj.value[Number(i.dict_sub_value)] = i.dict_sub_name
            })
            // console.log(reasonTypeObj.value,'vc')
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单来源类型
    const getOrderSource = async ()=>{
        let res = await OrderApi.getInstance().getOrderSource({status:'A'})
        if(res.code == 0){
            res.data.forEach(i=>{
                sourceObj.value[i.id] = i.id == 1? 'Shopify' : i.customer_name
            })
            // console.log(sourceObj.value,'sourceObj')
        }else{
            Message.error(res.msg)
        }
    }

    // 获取IBS验证方案类型
    const getIBSVerificationType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "IBS_verification_type"})
        if(res.code == 0){
            ibsVerificationTypeObj.value = []
            res.data.length > 0 && res.data.forEach(i=>{
                ibsVerificationTypeObj.value[Number(i.dict_sub_value)] = i.dict_sub_name
            })

            // console.log(ibsVerificationTypeObj.value,'ibsVerificationTypeObj')
        }else{
            Message.error(res.msg)
        }
    }

    // 发货详情
    const getShipDetail = async ()=>{
        let param = {
            "order_name":props.row.order_name,
            "frame_number":"",
            "order_status":"",
            "source":"",
            "courier_status":"",
            "order_channel_type":"",
            "customer_id":"",
            "country":"",
            "customer_email":"",
            "create_by":"",
            "instruction":"",
            "order_type":"",
            "invoice_no":"",
            "begin_date":"",
            "end_date":"",
            "risk_level":"",
            "erp_no":"",
            "sort_column":"",
            "sort_rule":""
        }
        reissueTable.value.configs.loading = true
        let res = await StockOutApi.getInstance().getShipDetail(param)
        if(res.code == 0){
            let data = res.data[0]
            console.log(data,'sign_time')
            detail.value = {
                type:props.row.type,
                order_name:data.order_name,
                status_val:props.row.status_val,
                status:props.row.status,
                source:!data.source? '-' : sourceObj.value[data.source],
                order_type_val: data.order_type,
                order_type: !data.order_type? '-' : data.order_type === 0? t('order.sale') : t('order.unSale'),
                order_use: !data.order_use? '-' : data.order_use,
                back_flag: !data.back_flag? '-' : data.back_flag,
                order_channel_type: !data.order_channel_type? '-' : data.order_channel_type == 0? t('order.user') : data.order_channel_type == 1? t('order.dealer') :data.order_channel_type == 2? t('order.ECommerceVendor') : t('order.notForSale'),
                order_timestamp: !data.order_timestamp? '-' : timestampToDate(data.order_timestamp * 1000),
                sign_time: !props.row.sign_time? '-' : props.row.sign_time,
                delivery_type: !data.delivery_type? '-' : data.delivery_type,
                tax_rate: !data.tax_rate? '-' : data.tax_rate * 100 +'%',
                // tax_type: !data.tax_type? '-' : data.tax_type,
                payment_type: !data.payment_type? '-' : data.payment_type,
                payment_type_discount: !data.payment_type_discount? '-' : data.payment_type_discount,
                pay_type_discount: !data.pay_type_discount? '-' : `€ ${data.pay_type_discount}`,
                cargo_freight: !data.cargo_freight? '-' : `€ ${data.cargo_freight}`,
                customer_name: !data.customer_name? '-' : data.customer_name,
                customer_invoice_name: !data.customer_invoice_name? '-' :data.customer_invoice_name,
                name2: !data.name2? '-' : data.name2,
                customer_email: !data.customer_email? '-' : data.customer_email,
                customer_type: !data.customer_type? '-' : data.customer_type == 0? t('order.user') : data.customer_type == 1? t('order.dealer') :data.customer_type == 2? t('order.ECommerceVendor') : t('order.notForSale'),
                country: !data.country? '-' : data.country,
            }
            console.log(detail.value,'del')
        }else{
            Message.error(res.msg)
        }
    }

    watch(()=>props.detailVisible,async (val)=>{
        // console.log(val,'detailVisible',props.type)
        await getReasonType()
        await getOrderSource()
        await getIBSVerificationType()
        getReissueList(props.type)
        init()
        
    })

    onMounted(()=>{
        
    })
</script>

<style lang="less" scoped>
.detailItem{
    padding-left: 30px;
    line-height: 40px;
    white-space: nowrap;
    
    .fieldName{
        display: inline-block;
        width: 200px;
        color: #333;
    }
    .fieldValue{
        display: inline-block;
        color: #888;
        vertical-align: -webkit-baseline-middle;
    }
}

.detailItemParent{
    display: flex;
    width: 100%;
    padding: 5px 0 20px;
    .detailItem_left,
    .detailItem_right{
        display: flex;
        flex: 1;
        flex-direction: column;
    }
}

/deep/ .arco-divider-text{
    font-weight: bold;
}
</style>